module.exports = __webpack_public_path__ + "img/brush.1e6263d2.svg";